module.exports = __webpack_public_path__ + "assets/5d21a5f266257c9ccd88188e07927644.png";